module.exports = __webpack_public_path__ + "static/media/surrounded_green_checkmark.fae2e493.jpg";